import { render, staticRenderFns } from "./cTemplateBuilderStructure.vue?vue&type=template&id=37157f10&scoped=true"
import script from "./cTemplateBuilderStructure.vue?vue&type=script&lang=js"
export * from "./cTemplateBuilderStructure.vue?vue&type=script&lang=js"
import style0 from "./cTemplateBuilderStructure.vue?vue&type=style&index=0&id=37157f10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37157f10",
  null
  
)

export default component.exports